/**
 * StayOnPageBanner Component
 *
 * A small corner badge reminding participants to stay on the page
 * during the experiment to avoid being marked as dropped out.
 */

import React from "react";

export function StayOnPageBanner() {
  return (
    <div className="fixed bottom-4 right-4 z-50 bg-amber-100 border border-amber-300 rounded-lg px-3 py-2 shadow-md max-w-xs">
      <p className="text-xs text-amber-800">
        <strong>Stay on page</strong> until complete
      </p>
    </div>
  );
}
